import AuthService from '@/services/auth';

export default {
  methods: {
    forceLogout() {
      this.$store.dispatch('setUser', null)
      this.$store.dispatch('setToken', null)
      this.$router.push('/')
    },
    logout() {
      let item = this;
      this.$swal.fire({
        title: 'Logout?',
        text: "Are you sure you want to logout?",
        type: 'info',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#6b6b6b',
        confirmButtonText: 'Logout'
      }).then((result) => {
        if (result.value) {
          this.$store.dispatch('setUser', null)
          this.$store.dispatch('setToken', null)
          this.$router.push({
            name: 'login'
          })
        }
      });
    },
    isLoggedIn() {
      return this.$store.state.user != null;
    },
    hasRole(role) {
      if(this.$store.state.user != null) {
        if(this.$store.state.user.role == role) {
          return true;
        }
      }
      return false;
    },
    isDev() {
      return process.env.VUE_APP_MODE === 'dev';
    },
    isPremium() {
      return this.$store.state.user.premium == true;
    },
    isAdmin(user) {
      if(user.role === 'admin')
        return true;
      return false;
    },
    checkPerms(route) {

      if(route.meta !== undefined) {

        if(route.meta.hidden == true)
          return false
        
        if(route.meta.requiresAuth == true) {
          if(this.isLoggedIn() == false) {
            return false
          }
        }

        if(route.meta.requiresNoAuth == true)
          if(this.isLoggedIn() == true)
            return false

        if(route.meta.requiresRole !== undefined) {
          if(this.hasRole(route.meta.requiresRole) == false) {
            if(!this.hasRole('admin') && !this.hasRole('superadmin'))
              return false
          }
        }

      }
      return true;
    }
  }
}